import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAPanel } from '../../panels/Panel';
import { IAToggle } from '../../toggle/Toggle';
import { Helper } from '../../../Helper';
import { ContentMapStore } from '../store';
import { IATextField } from '../../textField/TextField';
import { IANumberField } from '../../numberField/NumberField';
import { IAColorPicker } from '../../colorPicker/ColorPicker';
import { runInAction } from 'mobx';
import { IAOptionSelector } from '../../optionSelector/OptionSelector';
import { IAIconPicker } from '../../iconPicker/IconPicker';

export interface IDesignEditPanelProps {
  contentMapStore?: ContentMapStore;
  rerender: () => void;
}

@inject('contentMapStore')
@observer
export class DesignEditPanel extends React.Component<IDesignEditPanelProps> {

  private localizationService: LocalizationService = new LocalizationService();

  constructor(props: IDesignEditPanelProps) {
    super(props);
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    let top = 0;
    if (Helper.getDisplayEnvironment() === "Sharepoint" && !this.props.contentMapStore.isMobile) {
      top = 48;
    }
    if ((Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") && document.getElementById("IA_navigator_bar") && !document.getElementById("IA_navigator_vertical_menu") && !this.props.contentMapStore.isMobile) {
      top = 88;
    }
    return (
      <IAPanel
        panelId="DesignEditPanel"
        showNavigationBar={true}
        open={this.props.contentMapStore.showDesignEditPanel}
        transition={this.props.contentMapStore.showDesignEditPanel ? "fade" : "slide"}
        width={this.props.contentMapStore.isMobile ? window.innerWidth : 600}
        highlightColor={this.props.contentMapStore.highlightColor}
        marginTop={top}
        isMobile={this.props.contentMapStore.isMobile}
        close={() => this.props.contentMapStore.setShowDesignEditPanel(false)}
      >
        {this.props.contentMapStore.showDesignEditPanel &&
          <div
            style={{
              padding: "0px 40px 40px 40px",
              boxSizing: "border-box"
            }}
          >
            <IAToggle
              label={this.localizationService.strings.ContentMap_ShowTitle}
              checked={this.props.contentMapStore.contentMap.configuration.design.showTitle}
              color="#23879b"
              onChange={() => {
                runInAction(() => {
                  this.props.contentMapStore.contentMap.configuration.design.showTitle = !this.props.contentMapStore.contentMap.configuration.design.showTitle;
                });
                this.forceUpdate();
                this.props.rerender();
              }}
              style={{
                marginTop: 10
              }}
            />
            {this.props.contentMapStore.contentMap.configuration.design.showTitle &&
              <IATextField
                label={this.localizationService.strings.ContentMap_Title}
                text={this.props.contentMapStore.contentMap.configuration.design.title}
                onChange={(title: string) => {
                  runInAction(() => {
                    this.props.contentMapStore.contentMap.configuration.design.title = title;
                  });
                  this.forceUpdate();
                  this.props.rerender();
                }}
                borderRadius={5}
                style={{
                  marginTop: 10
                }}
              />
            }
            <IANumberField
              label={this.localizationService.strings.ContentMap_AmountOfColumns}
              number={this.props.contentMapStore.contentMap.configuration.design.amountOfColumns}
              onChange={(amountOfColumns: number) => {
                runInAction(() => {
                  this.props.contentMapStore.contentMap.configuration.design.amountOfColumns = amountOfColumns;
                });
                this.forceUpdate();
                this.props.rerender();
              }}
              borderRadius={5}
              inputProp={{
                min: 1,
                max: 5
              }}
              styles={{
                width: "100%"
              }}
            />
            <IAToggle
              label={this.localizationService.strings.ContentMap_ShowLine}
              checked={this.props.contentMapStore.contentMap.configuration.design.showLine}
              color="#23879b"
              onChange={() => {
                runInAction(() => {
                  this.props.contentMapStore.contentMap.configuration.design.showLine = !this.props.contentMapStore.contentMap.configuration.design.showLine;
                });
                this.forceUpdate();
                this.props.rerender();
              }}
              style={{
                marginTop: 10
              }}
            />
            <IAToggle
              label={this.localizationService.strings.ContentMap_ShowIconOnItems}
              checked={this.props.contentMapStore.contentMap.configuration.design.showIconOnItems}
              color="#23879b"
              onChange={() => {
                runInAction(() => {
                  this.props.contentMapStore.contentMap.configuration.design.showIconOnItems = !this.props.contentMapStore.contentMap.configuration.design.showIconOnItems;
                });
                this.forceUpdate();
                this.props.rerender();
              }}
              style={{
                marginTop: 10
              }}
            />
            {this.props.contentMapStore.contentMap.configuration.design.showIconOnItems &&
              <IAIconPicker
                label={this.localizationService.strings.ContentMap_SelectDefaultIcon}
                selectedIcon={this.props.contentMapStore.contentMap.configuration.design.defaultIcon}
                color={"#025159"}
                showTitle={true}
                select={(defaultIcon: string) => {
                  runInAction(() => {
                    this.props.contentMapStore.contentMap.configuration.design.defaultIcon = defaultIcon;
                  });
                  this.forceUpdate();
                  this.props.rerender();
                }}
                clear={() => {
                  runInAction(() => {
                    this.props.contentMapStore.contentMap.configuration.design.defaultIcon = "Link"
                  });
                }}
                shouldBeAbleToClear={true}
              />
            }
            <IANumberField
              label={this.localizationService.strings.ContentMap_AmountOfFirstLevelItemsToShow}
              number={this.props.contentMapStore.contentMap.configuration.design.amountOfFirstLevelItemsToShow}
              onChange={(amountOfFirstLevelItemsToShow: number) => {
                runInAction(() => {
                  this.props.contentMapStore.contentMap.configuration.design.amountOfFirstLevelItemsToShow = amountOfFirstLevelItemsToShow;
                });
                this.forceUpdate();
                this.props.rerender();
              }}
              borderRadius={5}
              styles={{
                width: "100%"
              }}
            />
            <IAToggle
              label={this.localizationService.strings.ContentMap_ExpandAsDefault}
              checked={this.props.contentMapStore.contentMap.configuration.design.expandAsDefault}
              color="#23879b"
              onChange={() => {
                runInAction(() => {
                  this.props.contentMapStore.contentMap.configuration.design.expandAsDefault = !this.props.contentMapStore.contentMap.configuration.design.expandAsDefault;
                });
                this.forceUpdate();
                this.props.rerender();
              }}
              style={{
                marginTop: 10
              }}
            />
            <IAColorPicker
              label={this.localizationService.strings.ContentMap_HighlightColor}
              color={this.props.contentMapStore.contentMap.configuration.design.highlightColor}
              defaultColor={this.props.contentMapStore.highlightColor}
              showClearButton={true}
              onChange={(highlightColor: string) => {
                runInAction(() => {
                  this.props.contentMapStore.contentMap.configuration.design.highlightColor = highlightColor;
                });
                this.forceUpdate();
                this.props.rerender();
              }}
              styles={{
                clear: "both",
                marginTop: 10
              }}
            />
            <IAColorPicker
              label={this.localizationService.strings.ContentMap_BackgroundColor}
              color={this.props.contentMapStore.contentMap.configuration.design.backgroundColor}
              defaultColor={"transparent"}
              showOpacity
              showClearButton={true}
              onChange={(backgroundColor: string) => {
                runInAction(() => {
                  this.props.contentMapStore.contentMap.configuration.design.backgroundColor = backgroundColor;
                });
                this.forceUpdate();
                this.props.rerender();
              }}
              styles={{
                marginTop: 10
              }}
            />
            <IAColorPicker
              label={this.localizationService.strings.ContentMap_TextColor}
              color={this.props.contentMapStore.contentMap.configuration.design.textColor}
              defaultColor={"#333333"}
              showClearButton={true}
              onChange={(textColor: string) => {
                runInAction(() => {
                  this.props.contentMapStore.contentMap.configuration.design.textColor = textColor;
                });
                this.forceUpdate();
                this.props.rerender();
              }}
              styles={{
                clear: "both",
                marginTop: 10
              }}
            />
            {this.props.contentMapStore.contentMap.configuration.design.showLine &&
              <IAColorPicker
                label={this.localizationService.strings.ContentMap_LineColor}
                color={this.props.contentMapStore.contentMap.configuration.design.lineColor}
                defaultColor={"#eeeeee"}
                showClearButton={true}
                onChange={(lineColor: string) => {
                  runInAction(() => {
                    this.props.contentMapStore.contentMap.configuration.design.lineColor = lineColor;
                  });
                  this.forceUpdate();
                  this.props.rerender();
                }}
                styles={{
                  marginTop: 10
                }}
              />
            }
            <IAToggle
              label={this.localizationService.strings.ContentMap_DropShadow}
              checked={this.props.contentMapStore.contentMap.configuration.design.dropShadow}
              color="#23879b"
              onChange={() => {
                runInAction(() => {
                  this.props.contentMapStore.contentMap.configuration.design.dropShadow = !this.props.contentMapStore.contentMap.configuration.design.dropShadow;
                });
                this.forceUpdate();
                this.props.rerender();
              }}
              style={{
                marginTop: 10
              }}
            />
            <IAOptionSelector
              label={this.localizationService.strings.Messages_Settings_BorderRadius}
              compact
              borderRadius={5}
              options={[
                {
                  image: "https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/borderRadius0.png",
                  key: "0px"
                },
                {
                  image: "https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/borderRadius5.png",
                  key: "5px"
                },
                {
                  image: "https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/borderRadius10.png",
                  key: "10px"
                },
                {
                  image: "https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/borderRadius20.png",
                  key: "20px"
                },
              ]}
              selected={this.props.contentMapStore.contentMap.configuration.design.borderRadius ?? "0px"}
              highlightColor={"#23879b"}
              onChange={(borderRadius: string) => {
                runInAction(() => {
                  this.props.contentMapStore.contentMap.configuration.design.borderRadius = borderRadius;
                });
                this.forceUpdate();
                this.props.rerender();
              }}
              style={{ clear: "none", marginTop: 20 }}
            />
          </div>
        }
      </IAPanel>
    );
  }
}